import React, { Fragment } from "react";
import { Link } from "gatsby";
import PropTypes from "prop-types";
import styles from "./style.module.scss";

const PaginationButton = ({ link, text }) => (
  <Fragment>
    {link ? (
      <Link className={styles.btn} title={link.title} to={`blog/${link.slug}`}>
        {text}
      </Link>
    ) : (
      <span className={styles.btnInactive}>{text}</span>
    )}
  </Fragment>
);

PaginationButton.propTypes = {
  link: PropTypes.shape({
    title: PropTypes.string,
    slug: PropTypes.string
  }),
  text: PropTypes.string.isRequired
};

PaginationButton.defaultProps = {
  link: null
};

export default PaginationButton;
